<template>
  <b-navbar toggleable="md" type="dark" variant="dark">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-navbar-brand :to="{name:'index'}"><i class="fa fa-comment-medical"></i> NHT <span class='small text-primary'>CLINIC</span></b-navbar-brand>
    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav class="ml-auto">
        <b-nav-item :to="{name:'index'}">Home</b-nav-item>
        <b-nav-item :to="{name:'about'}">About the App</b-nav-item>
        <b-nav-item v-if="$route.name=='test.begin'" :to="{name:'index'}">Abort Test</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import Relay from 'system/relay'
import Store from 'system/store'
import {
  BNavbar,BNavbarNav,BNavItem,BNavbarBrand,
  BCollapse,BNavbarToggle,VBToggle,BBreadcrumb,
  BNavItemDropdown,BDropdownItem
} from 'bootstrap-vue'
import Vue from 'vue'
Vue.directive('b-toggle',VBToggle)
export default {
  components: {BNavbar,BNavbarNav,BNavItem,BNavbarBrand,
  BCollapse,BNavbarToggle,BBreadcrumb,
  BNavItemDropdown,BDropdownItem},
  data(){
    return {state: Store.state}
  },
  methods: {
    logout: function(){
      Relay.get("SecureUser",{"act":"logout"},(response)=>{
        Relay.clearTokens()
        location.href="/"
      })
    }
  }
}
</script>
